var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.4C11.9406 17.4 11.8826 17.4176 11.8333 17.4505C11.7839 17.4835 11.7455 17.5303 11.7228 17.5852C11.7001 17.64 11.6941 17.7003 11.7057 17.7585C11.7173 17.8167 11.7459 17.8701 11.7878 17.9121C11.8298 17.9541 11.8832 17.9826 11.9414 17.9942C11.9996 18.0058 12.0599 17.9998 12.1148 17.9771C12.1696 17.9544 12.2164 17.916 12.2494 17.8666C12.2824 17.8173 12.3 17.7593 12.3 17.7C12.3 17.6204 12.2683 17.5441 12.2121 17.4878C12.1558 17.4316 12.0795 17.4 12 17.4Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.9999V8.99986",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2968 3.80782C13.1777 3.56543 12.9931 3.36126 12.7639 3.21847C12.5347 3.07569 12.2701 3 12 3C11.7299 3 11.4653 3.07569 11.2361 3.21847C11.0069 3.36126 10.8223 3.56543 10.7032 3.80782L3.12481 19.2464C3.03358 19.432 2.99116 19.6377 3.00153 19.8442C3.01191 20.0508 3.07475 20.2512 3.18411 20.4267C3.29347 20.6022 3.44576 20.747 3.62659 20.8473C3.80742 20.9476 4.01082 21.0001 4.21761 21H19.7824C19.9892 21.0001 20.1926 20.9476 20.3734 20.8473C20.5542 20.747 20.7065 20.6022 20.8159 20.4267C20.9253 20.2512 20.9881 20.0508 20.9985 19.8442C21.0088 19.6377 20.9664 19.432 20.8752 19.2464L13.2968 3.80782Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.887c9deb070a0caf86be87f0a4d1b1e8.svg";
export { ForwardRef as ReactComponent };